if (!window.__shQtyPrice) {
  window.__shQtyPrice = true;

  const DEFAULT_TIERS = [
    { qty: 2, percent: 5 },
    { qty: 5, percent: 7 },
    { qty: 10, percent: 10 },
    { qty: 15, percent: 12 }
  ];

  const getTiers = (productId) => {
    const box = document.querySelector('sh-discount-box[data-product-id="' + productId + '"]');
    if (!box) return DEFAULT_TIERS.slice();

    const tiers = Array.from(box.querySelectorAll('[data-sh-discount-step]'))
      .map((step) => ({
        qty: Number(step.dataset.qty || 0),
        percent: Number(step.dataset.percent || 0)
      }))
      .filter((tier) => tier.qty > 0);

    const extraQty = Number(box.dataset.qtyExtra || 0);
    const extraPercent = Number(box.dataset.percentExtra || 0);
    if (extraQty > 0) {
      tiers.push({ qty: extraQty, percent: extraPercent });
    }

    if (!tiers.length) return DEFAULT_TIERS.slice();
    return tiers.sort((a, b) => a.qty - b.qty);
  };

  const getQuantityInput = (productId) => {
    const info = document.querySelector('product-info[data-product-id="' + productId + '"]');
    if (info) {
      const scoped = info.querySelector('.sh-quantity-box input[name="quantity"]');
      if (scoped) return scoped;
    }
    return document.querySelector('.sh-quantity-box input[name="quantity"]');
  };

  const getQuantity = (productId) => {
    const input = getQuantityInput(productId);
    const qty = input ? Number(input.value || 0) : 1;
    return Number.isNaN(qty) || qty < 1 ? 1 : qty;
  };

  const percentForQty = (tiers, qty) => {
    let percent = 0;
    tiers.forEach((tier) => {
      if (qty >= tier.qty) percent = tier.percent;
    });
    return percent;
  };

  const unitPriceFor = (basePrice, percent) => Math.round((Number(basePrice || 0) * (100 - percent)) / 100);

  const moneyFormatFrom = (el) => {
    if (el && el.dataset.moneyFormat) return el.dataset.moneyFormat;
    if (window.theme && theme.settings) {
      return theme.settings.currencyCodeEnabled
        ? theme.settings.moneyWithCurrencyFormat
        : theme.settings.moneyFormat;
    }
    return '{{amount}}';
  };

  const formatMoney = (cents, format, stripZeros) => {
    let formatted = String(cents);
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      formatted = theme.Currency.formatMoney(cents, format || '{{amount}}');
    }
    if (stripZeros && Number(cents) % 100 === 0) {
      formatted = formatted.replace(/([.,]00)(?=\D|$)/, '');
    }
    return formatted;
  };

  const buildBadge = (template, savingsCents, format) => {
    const amount = formatMoney(savingsCents, format, true);
    const text = template || '';
    if (text.indexOf('[amount]') !== -1) return text.split('[amount]').join(amount);
    if (text) return (text + ' ' + amount).trim();
    return amount;
  };

  const updatePriceGroup = (sellEl, compareEl, badgeEl, root, unit, compare, format) => {
    const showCompare = !root || root.dataset.showCompare !== 'false';
    const showBadgeSetting = !root || root.dataset.showBadge !== 'false';
    const onSale = compare > unit;

    if (sellEl) sellEl.textContent = formatMoney(unit, format, false);

    if (compareEl) {
      if (compare > 0) compareEl.textContent = formatMoney(compare, format, false);
      compareEl.classList.toggle('hidden', !(showCompare && onSale));
    }

    if (badgeEl) {
      const showBadge = showBadgeSetting && onSale;
      if (showBadge) {
        badgeEl.textContent = buildBadge(root && root.dataset.badgeText, compare - unit, format);
      }
      badgeEl.classList.toggle('hidden', !showBadge);
    }

    if (root && root.classList) {
      root.classList.toggle('sh-price--on-sale', onSale);
      root.classList.toggle('sh-order-cta--on-sale', onSale);
      root.classList.toggle('sh-final-cta--on-sale', onSale);
    }
  };

  const apply = (productId) => {
    if (!productId) return;

    const priceRoot = document.querySelector('[data-sh-qty-price][data-product-id="' + productId + '"]');
    const box = document.querySelector('sh-discount-box[data-product-id="' + productId + '"]');
    const orderCta = document.querySelector('sh-order-cta[data-product-id="' + productId + '"]');
    const finalCta = document.querySelector('sh-final-cta[data-product-id="' + productId + '"]');

    const basePrice = Number(
      (priceRoot && priceRoot.dataset.basePrice) ||
        (box && box.dataset.price) ||
        0
    );
    const comparePrice = Number(
      (priceRoot && priceRoot.dataset.comparePrice) ||
        (orderCta && orderCta.dataset.comparePrice) ||
        (finalCta && finalCta.dataset.comparePrice) ||
        0
    );

    const tiers = getTiers(productId);
    const qty = getQuantity(productId);
    const percent = percentForQty(tiers, qty);
    const unit = unitPriceFor(basePrice, percent);
    const format = moneyFormatFrom(priceRoot || orderCta || finalCta || box);

    if (priceRoot) {
      updatePriceGroup(
        priceRoot.querySelector('[data-sh-price-sell]'),
        priceRoot.querySelector('[data-sh-price-compare]'),
        priceRoot.querySelector('[data-sh-price-badge]'),
        priceRoot,
        unit,
        comparePrice,
        format
      );
    }

    if (orderCta) {
      updatePriceGroup(
        orderCta.querySelector('[data-sh-oc-price]'),
        orderCta.querySelector('[data-sh-oc-compare]'),
        orderCta.querySelector('[data-sh-oc-badge]'),
        orderCta,
        unit,
        Number(orderCta.dataset.comparePrice || comparePrice),
        moneyFormatFrom(orderCta) || format
      );
    }

    if (finalCta) {
      updatePriceGroup(
        finalCta.querySelector('[data-sh-fct-price]'),
        finalCta.querySelector('[data-sh-fct-compare]'),
        finalCta.querySelector('[data-sh-fct-badge]'),
        finalCta,
        unit,
        Number(finalCta.dataset.comparePrice || comparePrice),
        moneyFormatFrom(finalCta) || format
      );
    }

    document.dispatchEvent(
      new CustomEvent('sh:qty-price-update', {
        detail: { productId, qty, percent, basePrice, unitPrice: unit, comparePrice, tiers }
      })
    );
  };

  const productIdFromQuantityInput = (input) => {
    if (!input || !input.closest) return '';
    if (!input.closest('.sh-quantity-box')) return '';
    const holder = input.closest('quantity-input');
    if (holder && holder.dataset.productId) return String(holder.dataset.productId);
    const info = input.closest('product-info');
    if (info && info.dataset.productId) return String(info.dataset.productId);
    return '';
  };

  document.addEventListener('change', (event) => {
    const productId = productIdFromQuantityInput(event.target);
    if (productId) apply(productId);
  });

  document.addEventListener('input', (event) => {
    const productId = productIdFromQuantityInput(event.target);
    if (productId) apply(productId);
  });

  const onVariantChange = (event) => {
    const data = (event && event.data) || (event && event.detail) || {};
    const variant = data.variant;
    if (!variant) return;
    let productId = String(data.productId || '');
    if (!productId) {
      const info = document.querySelector('product-info[data-product-id]');
      if (info) productId = String(info.dataset.productId || '');
    }
    if (!productId) return;

    window.setTimeout(() => {
      const priceRoot = document.querySelector('[data-sh-qty-price][data-product-id="' + productId + '"]');
      if (priceRoot) {
        priceRoot.dataset.basePrice = String(variant.price || 0);
        priceRoot.dataset.comparePrice = String(variant.compare_at_price || 0);
      }
      const box = document.querySelector('sh-discount-box[data-product-id="' + productId + '"]');
      if (box) box.dataset.price = String(variant.price || 0);
      const orderCta = document.querySelector('sh-order-cta[data-product-id="' + productId + '"]');
      if (orderCta) orderCta.dataset.comparePrice = String(variant.compare_at_price || 0);
      const finalCta = document.querySelector('sh-final-cta[data-product-id="' + productId + '"]');
      if (finalCta) finalCta.dataset.comparePrice = String(variant.compare_at_price || 0);
      apply(productId);
    }, 0);
  };

  const bindPubsub = () => {
    if (window.__shQtyPricePubsub) return true;
    if (!(window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS)) return false;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantChange);
    window.__shQtyPricePubsub = true;
    return true;
  };

  document.addEventListener('variant:change', onVariantChange);
  if (!bindPubsub()) {
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (bindPubsub() || tries > 40) window.clearInterval(timer);
    }, 50);
  }

  const boot = () => {
    document.querySelectorAll('[data-sh-qty-price][data-product-id]').forEach((el) => {
      apply(el.dataset.productId);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ShQtyPrice = { apply, getTiers, getQuantity, percentForQty, unitPriceFor };
}
